import React from 'react';
import { Link } from 'react-router-dom';
import { mockPrograms } from '../data/mockData';

const ProgramsSection = () => {
const scrollToContact = () => {
const element = document.getElementById('contact');

if (element) {
  element.scrollIntoView({ behavior: 'smooth' });
}

};

return (
<section id="programs" className="bg-zinc-950 py-20 md:py-32" aria-labelledby="programs-heading" >
<div className="container mx-auto px-6">

    {/* Section Header */}
    <div className="text-center mb-16">

      <h2
        id="programs-heading"
        className="text-white text-5xl md:text-6xl font-bold mb-6"
      >
        Boxing & Fitness Training Programs
      </h2>

      <p className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto">
        Develop your boxing skills, improve your fitness and build
        discipline through structured training programmes at
        Bond Boxing in Gaborone, Botswana. Whether you're starting
        your boxing journey or developing your competitive skills,
        explore our available programmes.
      </p>

    </div>

    {/* Programs Grid */}
    <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">

      {mockPrograms.map((program, index) => (

        <article
          key={program.id || program.title || index}
          className="bg-black border border-gray-800 hover:border-red-600 transition-all duration-300 group hover:shadow-xl hover:shadow-red-600/20 hover:-translate-y-2"
        >

          <div className="p-8">

            {/* Category */}
            <div className="text-red-600 text-sm font-semibold mb-3 tracking-wider">
              {program.category}
            </div>

            {/* Program Title */}
            <h3 className="text-white text-2xl font-bold mb-4 group-hover:text-red-500 transition-colors duration-300">
              {program.title}
            </h3>

            {/* Description */}
            <p className="text-gray-400 mb-6 leading-relaxed">
              {program.description}
            </p>

            {/* CTA */}
            <button
              type="button"
              onClick={scrollToContact}
              className="text-red-500 hover:text-white font-semibold flex items-center gap-2 transition-colors duration-300"
              aria-label={`Enquire about ${program.title}`}
            >
              Enquire About Program
              <span aria-hidden="true">→</span>
            </button>

          </div>

        </article>

      ))}

    </div>

    {/* Additional Navigation */}
    <div className="text-center mt-12">
      <Link
        to="/gym"
        className="inline-block border border-red-600 text-red-500 hover:bg-red-600 hover:text-white px-8 py-4 font-semibold transition-all duration-300"
      >
        Explore Our Boxing Gym
      </Link>
    </div>

  </div>
</section>

);
};

export default ProgramsSection;